import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// items: array of objects, e.g., [{ path: '/foo', label: 'Foo' }, { label: 'Bar' (current page) }]
const BreadcrumbNavigation = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb listProps={{ className: 'mb-3 mt-3' }}> {/* Add some margin */}
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Breadcrumb.Item 
            key={index} 
            linkAs={isLast ? 'span' : Link} 
            linkProps={isLast ? {} : { to: item.path }} 
            active={isLast}
          >
            {item.label}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default BreadcrumbNavigation;
